<template>
  <div class="sidebar d-flex flex-column border-left glass-sidebar h-100" style="width: 320px; flex-shrink: 0; z-index: 30">
    <div class="pa-4 border-bottom d-flex align-center justify-space-between glass-header-inner">
      <div class="text-subtitle-1 font-weight-bold white--text d-flex align-center">
        <v-icon color="blue accent-2" class="mr-2">mdi-view-dashboard-outline</v-icon>
        Vorlagen
      </div>
      <v-btn icon small color="blue accent-2" @click="$emit('create')"><v-icon>mdi-plus</v-icon></v-btn>
    </div>

    <div class="flex-grow-1 overflow-y-auto custom-scrollbar pa-3">
      <div class="section-label mb-2 mt-1 orange--text text--accent-3 text-caption font-weight-bold text-uppercase d-flex align-center">
        <v-icon x-small color="orange accent-3" class="mr-1">mdi-lightning-bolt</v-icon> Workflows
      </div>

      <div
        v-for="tpl in workflowTemplates"
        :key="tpl.id"
        class="template-card mb-2 pa-3 rounded-lg d-flex align-center cursor-grab elevation-2 glass-card relative overflow-hidden"
        draggable="true"
        @dragstart="onDragStart($event, tpl)">
        <div class="color-strip" :style="{ background: tpl.color }"></div>

        <v-avatar size="36" :color="tpl.color + '20'" class="mr-3 rounded-lg">
          <v-icon small :color="tpl.color">{{ tpl.icon }}</v-icon>
        </v-avatar>

        <div class="flex-grow-1 overflow-hidden">
          <div class="font-weight-bold white--text text-body-2">{{ tpl.title }}</div>
          <div class="text-caption grey--text">{{ tpl.duration }} Min • Kunde</div>
        </div>
        <v-icon small color="grey" class="opacity-50">mdi-drag-vertical</v-icon>
      </div>

      <v-divider class="my-4 border-light opacity-50"></v-divider>

      <div class="section-label mb-2 mt-1 green--text text--accent-3 text-caption font-weight-bold text-uppercase">Quick Actions</div>
      <div
        v-for="tpl in actionTemplates"
        :key="tpl.id"
        class="template-card mb-2 pa-3 rounded-lg d-flex align-center cursor-grab elevation-2 glass-card relative overflow-hidden"
        draggable="true"
        @dragstart="onDragStart($event, tpl)">
        <div class="color-strip" :style="{ background: tpl.color }"></div>

        <v-avatar size="36" :color="tpl.color + '20'" class="mr-3 rounded-lg">
          <v-icon small :color="tpl.color">{{ tpl.icon }}</v-icon>
        </v-avatar>

        <div class="flex-grow-1 overflow-hidden">
          <div class="font-weight-bold white--text text-body-2">{{ tpl.title }}</div>
          <div class="text-caption grey--text">{{ tpl.duration }} Min</div>
        </div>
        <v-icon small color="grey" class="opacity-50">mdi-drag-vertical</v-icon>
      </div>

      <v-divider class="my-4 border-light opacity-50"></v-divider>

      <div class="section-label mb-2 pl-1 blue--text text--accent-2 text-caption font-weight-bold text-uppercase">Eigene Vorlagen</div>
      <div
        v-for="tpl in appointmentTemplates"
        :key="tpl._id"
        class="template-card mb-2 pa-3 rounded-lg d-flex align-center cursor-grab elevation-2 glass-card relative overflow-hidden"
        draggable="true"
        @dragstart="onDragStart($event, tpl)">
        <div class="color-strip" :style="{ background: tpl.color || 'blue' }"></div>

        <v-avatar size="36" :color="(tpl.color || 'blue') + '20'" class="mr-3 rounded-lg">
          <v-icon small :color="tpl.color || 'blue'">{{ tpl.icon || "mdi-calendar" }}</v-icon>
        </v-avatar>
        <div class="flex-grow-1 overflow-hidden">
          <div class="font-weight-bold white--text text-body-2 text-truncate">{{ tpl.title }}</div>
          <div class="text-caption grey--text">{{ tpl.duration }} Min <span v-if="tpl.requiresCustomer">• Kunde</span></div>
        </div>
        <v-icon small color="grey" class="handle-icon opacity-50">mdi-drag-vertical</v-icon>
      </div>

      <div class="section-label mb-2 pl-1 purple--text text--accent-2 text-caption font-weight-bold text-uppercase mt-4">Ämtli & Aufgaben</div>
      <div
        v-for="tpl in taskTemplates"
        :key="tpl._id"
        class="template-card mb-2 pa-3 rounded-lg d-flex align-center cursor-grab elevation-2 glass-card relative overflow-hidden"
        draggable="true"
        @dragstart="onDragStart($event, tpl)">
        <div class="color-strip" :style="{ background: tpl.color || 'purple' }"></div>

        <v-avatar size="36" tile class="mr-3 rounded bg-transparent">
          <v-icon :color="tpl.color || 'purple'">{{ tpl.icon || "mdi-checkbox-marked" }}</v-icon>
        </v-avatar>
        <div class="flex-grow-1 overflow-hidden">
          <div class="font-weight-bold white--text text-body-2 text-truncate">{{ tpl.title }}</div>
          <div class="text-caption grey--text">Aufgabe</div>
        </div>
        <v-icon small color="grey" class="handle-icon opacity-50">mdi-drag-vertical</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WorkCalendarSidebar",
  props: {
    templates: { type: Array, default: () => [] },
  },
  data() {
    return {
      // 1. Die neuen Workflow-Templates (Passend zum Dialog Theme)
      workflowTemplates: [
        {
          id: "wf1",
          title: "Probetraining",
          type: "appointment",
          specialType: "trial",
          duration: 90,
          color: "#FF9800", // Orange
          icon: "mdi-account-star",
          requiresCustomer: true,
        },
        {
          id: "wf2",
          title: "Einführung",
          type: "appointment",
          specialType: "intro",
          duration: 60,
          color: "#00BCD4", // Cyan
          icon: "mdi-rocket-launch",
          requiresCustomer: true,
        },
        {
          id: "wf3",
          title: "Personal Training",
          type: "appointment",
          specialType: "pt",
          duration: 60,
          color: "#FFD700", // Gold
          icon: "mdi-crown",
          requiresCustomer: true,
        },
      ],
      // 2. Standard Aktionen
      actionTemplates: [
        {
          id: "act1",
          title: "Trainingsplan",
          type: "appointment",
          specialType: "workout",
          duration: 60,
          color: "#2196F3", // Blau
          icon: "mdi-dumbbell",
          requiresCustomer: true,
        },
        {
          id: "act2",
          title: "Check-Up / Re-Test",
          type: "appointment",
          specialType: "checkup",
          duration: 30,
          color: "#E91E63", // Pink
          icon: "mdi-heart-pulse",
          requiresCustomer: true,
        },
        {
          id: "act3",
          title: "Anamnese (Einzeln)",
          type: "appointment",
          specialType: "anamnese",
          duration: 30,
          color: "#009688", // Teal
          icon: "mdi-clipboard-pulse",
          requiresCustomer: true,
        },
        {
          id: "act4",
          title: "Vertrag / Upgrade",
          type: "appointment",
          specialType: "upgrade",
          duration: 30,
          color: "#AA00FF", // Purple
          icon: "mdi-star-circle",
          requiresCustomer: true,
        },
      ],
    }
  },
  computed: {
    // Filtert die Templates aus der Datenbank (Props)
    appointmentTemplates() {
      return this.templates.filter((t) => t.type === "appointment")
    },
    taskTemplates() {
      return this.templates.filter((t) => t.type === "task")
    },
  },
  methods: {
    onDragStart(e, tpl) {
      // WICHTIG: create Flag setzen, damit der Kalender weiß, es ist neu
      const dragObj = { ...tpl, create: true }

      e.dataTransfer.setData("templateObj", JSON.stringify(dragObj))
      e.dataTransfer.effectAllowed = "copy"
      this.$emit("drag-start", dragObj)
    },
  },
}
</script>

<style scoped>
.glass-sidebar {
  background: rgba(20, 20, 20, 0.95);
  backdrop-filter: blur(20px);
  border-left: 1px solid rgba(255, 255, 255, 0.1);
}
.glass-header-inner {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
/* Ersetze die .glass-card Klasse mit dieser optimierten Version */
.glass-card {
  /* KEIN backdrop-filter hier! Das ist der Performance-Killer beim Draggen */
  background: rgba(40, 40, 40, 0.6); /* Etwas dunkler/solider */
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: transform 0.1s ease; /* Schnelleres Feedback */
  /* Hardware Beschleunigung aktivieren */
  will-change: transform;
  transform: translate3d(0, 0, 0);
}

.glass-card:hover {
  background: rgba(60, 60, 60, 0.8);
  transform: translateY(-2px);
  /* Schatten nur beim Hover und ohne riesigen Blur-Radius */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
}

/* Color Strip Links */
.color-strip {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  opacity: 0.8;
}

.border-light {
  border-color: rgba(255, 255, 255, 0.1) !important;
}
.cursor-grab {
  cursor: grab;
}
.cursor-grab:active {
  cursor: grabbing;
}

/* Custom Scrollbar */
.custom-scrollbar::-webkit-scrollbar {
  width: 5px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 3px;
}
</style>
